import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import NavbarComponent from './NavbarComponent';
import Footer from './Footer';

const TermsPageP = () => {
  useEffect(() => {
      const hash = window.location.hash; // Extract hash from URL
      if (hash) {
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            requestAnimationFrame(() => {
              element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
  
            // Fallback for elements near the bottom
            setTimeout(() => {
              window.scrollTo({ top: element.offsetTop, behavior: 'smooth' });
            }, 500);
          }
        }, 300); // Delay to ensure content is rendered
      }
    }, []);

  return (
    <>
      <NavbarComponent/>
        <Container className="my-4 terms-page">
          {/* Declaração de Privacidade */}
          <section className="mb-4" id='s0'>
            <Row>
              <Col>
                <h2 className="terms-page-header">Declaração de Privacidade</h2>
                {/* <p>Mantenha isso em branco por enquanto e clicar no link não deve abrir nada.</p> */}
              </Col>
            </Row>
          </section>

          {/* Termos de Uso */}
          <section className="mb-4" id='s1'>
            <Row>
              <Col>
                <h2 className="terms-page-header">Termos de Uso</h2>
                <p>
                  Ao acessar e usar este site, você concorda com os seguintes termos e condições sem limitações ou qualificações.
                </p>

                <h5 className="section-common-title">Conformidade com Leis</h5>
                <p>
                  Você é responsável por cumprir as leis aplicáveis à sua jurisdição ao acessar este site. Qualquer informação
                  que você enviar através deste site será tratada como não confidencial e não proprietária. Você afirma que possui o
                  direito legal de enviar essas informações.
                </p>

                <h5 className="section-common-title">Propriedade do Conteúdo</h5>
                <p>
                  Salvo especificação em contrário, todo o conteúdo deste site, incluindo textos, imagens e sua disposição, pertence à 720
                  Degrees e suas afiliadas. Todas as marcas registradas mencionadas são propriedade de seus respectivos proprietários.
                </p>

                <h5 className="section-common-title">Restrições de Licença</h5>
                <p>
                  Nada neste site concede qualquer licença ou direito a qualquer direito autoral, patente, marca registrada ou interesse proprietário da 720
                  Degrees ou de qualquer terceiro. O conteúdo — incluindo imagens gráficas, áudio, vídeo, código HTML, botões e texto — não pode ser
                  copiado, reproduzido, republicado, carregado, postado, transmitido ou distribuído sem o consentimento prévio por escrito da 720
                  Degrees. Você pode baixar e imprimir uma cópia dos materiais para uso pessoal e não comercial apenas se não os modificar
                  e mantiver todos os avisos de direitos autorais e marcas registradas.
                </p>

                <h5 className="section-common-title">Envio Não Autorizado de Ideias</h5>
                <p>
                  A 720 Degrees não aceita envios de ideias não solicitadas fora de relações comerciais estabelecidas. Quaisquer ideias compartilhadas
                  sem um relacionamento confidencial documentado são consideradas não confidenciais; a 720 Degrees pode desenvolver ou divulgar
                  ideias semelhantes sem compensação. Submissões não autorizadas podem ser devolvidas ou destruídas a nosso critério sem
                  revisão detalhada. Ao enviar ideias por meio deste site, você concorda com estes termos.
                </p>

                <h5 className="section-common-title">Isenção de Informações</h5>
                <p>
                  As informações fornecidas neste site são oferecidas gratuitamente apenas para fins informativos e não criam uma
                  relação de serviços comerciais ou profissionais entre você e a 720 Degrees. Links para sites externos não são
                  endossos; a 720 Degrees não é responsável pelo conteúdo ou serviços desses sites. O uso de informações deste site ou de sites vinculados é por sua conta e risco.
                </p>

                <h5 className="section-common-title">Limitação de Responsabilidade</h5>
                <p>
                  Este site e seus conteúdos são fornecidos "como estão". A 720 Degrees não oferece garantias em relação ao site ou a quaisquer serviços vinculados
                  e renuncia expressamente a todas as garantias implícitas, incluindo aquelas de comercialização e adequação para um propósito específico. Nem a 720 Degrees nem seus provedores de serviços terceirizados serão responsáveis por quaisquer danos decorrentes do uso deste site ou serviços vinculados.
                </p>

                <h5 className="section-common-title">Lei Aplicável</h5>
                <p>
                  Este site é mantido na nuvem AWS. Estes termos são regidos pelas leis de São Paulo, Brasil. Você reconhece que a 720
                  Degrees pode escolher a jurisdição para quaisquer processos legais contra ela.
                </p>
              </Col>
            </Row>
          </section>

          {/* Divulgação Responsável */}
          <section className="mb-4" id='s2'> 
            <Row>
              <Col>
                <h2 className="terms-page-header">Divulgação Responsável</h2>
                <p>
                  Na 720 Degrees, priorizamos a segurança de nossas aplicações e dos dados que gerenciamos. Agradecemos qualquer informação que
                  possa nos ajudar a melhorar nossa postura de segurança.
                </p>
                <ul>
                  <li>
                    <strong>Porto Seguro:</strong> Se você relatar uma vulnerabilidade usando o processo descrito e cumprir estes termos, não
                    tomaremos medidas legais contra você por acesso não autorizado para identificar a vulnerabilidade.
                  </li>
                  <li>
                    <strong>Processo de Submissão:</strong> Envie relatórios de vulnerabilidades para info@720Degrees.ai, incluindo:-<br/>
                    - Descrição da vulnerabilidade<br/>
                    - URL relevante, endereço IP ou outras informações de identificação<br/>
                    - Etapas para reproduzir o problema (incluindo logs ou capturas de tela)<br/>
                    - Como você descobriu o problema<br/>
                    - Impacto presumido<br/>
                    - Etapas sugeridas para remediação<br/>
                    - Seu nome e informações de contato
                  </li>
                  <li>
                    <strong>Escopo:</strong> Não acesse estações de trabalho, sistemas ou redes de terceiros. O porto seguro não se aplica a tais sistemas.
                  </li>
                  <li>
                    <strong>Metodologia:</strong> Evite ataques de negação de serviço ou quaisquer métodos destrutivos. Interrompa os testes assim que identificar uma vulnerabilidade e relate-a conforme as instruções.
                  </li>
                  <li>
                    <strong>Acesso a Dados:</strong> Você não deve acessar dados pessoais de nossos clientes ou usuários. Caso adquira esses dados inadvertidamente, exclua-os com segurança.
                  </li>
                  <li>
                    <strong>Propriedade Intelectual:</strong> Ao enviar um relatório, você nos concede uma licença perpétua para usar e divulgar as informações fornecidas para análise e melhoria.
                  </li>
                  <li>
                    <strong>Isenção de Responsabilidade:</strong> A 720 Degrees não se responsabiliza por quaisquer danos relacionados à sua submissão. Todas as informações enviadas são fornecidas gratuitamente, e nenhuma taxa será paga pelas submissões.
                  </li>
                  <li>
                    <strong>Lei Aplicável:</strong> Estes termos são regidos pelas leis de São Paulo, Brasil.
                    Ao participar deste programa, você reconhece e aceita estes termos. Obrigado por nos ajudar a melhorar nossa segurança!
                  </li>
                </ul>
              </Col>
            </Row>
          </section>

          {/* Preferências de Cookies */}
          <section className="mb-4" id='s3'>
            <Row>
              <Col>
                <h2 className="terms-page-header">Preferências de Cookies</h2>
                <p>
                  Usamos cookies para fornecer serviços personalizados melhores. Você tem a opção de limitar apenas aos cookies essenciais.
                </p>
              </Col>
            </Row>
          </section>

          {/* Mapa do Site */}
          <section className="mb-4" id='s4'>
            <Row>
              <Col>
                <h2 className="terms-page-header">Mapa do Site</h2>
                {/* <p>A equipe técnica precisa construir.</p> */}
              </Col>
            </Row>
          </section>
        </Container>
      <Footer/>
    </>
  );
};

export default TermsPageP;
